import React from 'react';
import { Assumptions } from '../types/compensation';
import { computeModel, defaultAssumptions } from '../utils/compensation';
import { presets } from '../data/presets';
import { PresetBar } from '../components/PresetBar';
import { LeverPanel } from '../components/LeverPanel';
import { ResultCard } from '../components/ResultCard';
import { AssumptionsPanel } from '../components/AssumptionsPanel';
interface ConfiguratorProps {
  initialPreset: string;
}
export function Configurator({
  initialPreset
}: ConfiguratorProps) {
  const start = presets.find(p => p.id === initialPreset) ?? presets[0];
  const [assumptions, setAssumptions] = React.useState<Assumptions>(defaultAssumptions);
  const [fixedMonthly, setFixedMonthly] = React.useState(start.fixedMonthly);
  const [commissionShare, setCommissionShare] = React.useState(start.commissionShare);
  const model = computeModel(fixedMonthly, commissionShare, assumptions);
  const activePreset = presets.find(p => p.fixedMonthly === model.fixedMonthly && Math.abs(p.commissionShare - model.commissionShare) < 0.005)?.id ?? null;
  const applyPreset = (id: string) => {
    const preset = presets.find(p => p.id === id);
    if (!preset) return;
    setFixedMonthly(preset.fixedMonthly);
    setCommissionShare(preset.commissionShare);
  };
  const patchAssumptions = (patch: Partial<Assumptions>) => setAssumptions(prev => ({
    ...prev,
    ...patch
  }));
  return <main className="min-h-screen w-full bg-ink-950 text-paper" data-id="element-138" data-mp="4a0zcyge0bvu">
      <header className="border-b border-line" data-id="element-139" data-mp="3vfskfjfb4ybs">
        <div className="mx-auto flex max-w-[1120px] items-center justify-between gap-6 px-5 py-5 lg:px-10" data-id="element-140" data-mp="d8w5ybncfnzo">
          <span className="text-base font-semibold tracking-tight text-paper" data-id="element-141" data-mp="97ixdtsv96p2">
            Snakker<span className="text-paper-dim" data-id="element-142" data-mp="1oo17vdfnhii8">.io</span>
          </span>
          <span className="text-xs uppercase tracking-[0.16em] text-paper-dim" data-id="element-143" data-mp="1om83y5wf9cdx">
            Senior Commercial Lead · Pharma
          </span>
        </div>
      </header>

      <div className="mx-auto max-w-[1120px] px-5 pb-28 pt-12 lg:px-10 lg:pt-16" data-id="element-144" data-mp="hah3la1fjpnp">
        <div className="max-w-2xl" data-id="element-145" data-mp="m9tzekaa472f">
          <h1 className="text-[38px] font-semibold leading-[1.05] tracking-tightest text-paper lg:text-[54px]" data-id="element-146" data-mp="m924zcsf4fdq">
            Design your compensation mix
          </h1>
          <p className="mt-4 text-lg leading-relaxed text-paper-muted" data-id="element-147" data-mp="vbl0fbtvjppy">
            Move the sliders — the package updates instantly.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 items-start gap-6 lg:grid-cols-12" data-id="element-148" data-mp="3k56sxtwh2q8">
          <div className="space-y-4 lg:col-span-7" data-id="element-149" data-mp="3i17yuauytwt">
            <AssumptionsPanel assumptions={assumptions} onChange={patchAssumptions} onReset={() => setAssumptions(defaultAssumptions)} data-id="element-150" data-mp="7ko251v04qx6" />
            <PresetBar activeId={activePreset} onSelect={applyPreset} data-id="element-151" data-mp="3c0qlmv97qq19" />
            <LeverPanel model={model} assumptions={assumptions} onFixedChange={setFixedMonthly} onShareChange={setCommissionShare} data-id="element-152" data-mp="3g1isxiyiykuw" />
          </div>

          <div className="lg:sticky lg:top-6 lg:col-span-5" data-id="element-153" data-mp="33ievdtxmoaoh">
            <ResultCard model={model} assumptions={assumptions} data-id="element-154" data-mp="33gtwxt8707lc" />
          </div>
        </div>
      </div>
    </main>;
}